export class CodedError extends Error{code;info;constructor(code,message){super(message),this.code=code}}